export const earlyAccessAr = {
  'earlyAccess.title': 'اطلب الوصول المبكر',
  'earlyAccess.subtitle':
    'أخبرنا من أنت وما الذي تريد من ووركرايز مساعدتك على فهمه أو تحسينه. سنستخدم ذلك لإدارة الوصول عند الإطلاق فقط.',
  'earlyAccess.field.name': 'الاسم',
  'earlyAccess.field.email': 'البريد الإلكتروني',
  'earlyAccess.field.interestedAs': 'مهتم بصفة',
  'earlyAccess.field.company': 'الشركة',
  'earlyAccess.field.role': 'الدور',
  'earlyAccess.field.useCase': 'حالة الاستخدام',
  'earlyAccess.field.consent':
    'أوافق على التواصل معي بخصوص الوصول المبكر إلى ووركرايز.',
  'earlyAccess.option.candidate': 'مرشح',
  'earlyAccess.option.employer': 'صاحب عمل',
  'earlyAccess.option.company': 'شركة',
  'earlyAccess.option.partner': 'شريك',
  'earlyAccess.option.other': 'أخرى',
  'earlyAccess.placeholder.name': 'اسمك الكامل',
  'earlyAccess.placeholder.email': 'you@example.com',
  'earlyAccess.placeholder.company': 'الشركة أو المؤسسة',
  'earlyAccess.placeholder.role': 'دورك الحالي',
  'earlyAccess.placeholder.useCase':
    'ما الذي تريد من ووركرايز مساعدتك على فهمه أو تحسينه؟',
  'earlyAccess.submit': 'طلب الوصول',
  'earlyAccess.submitting': 'جارٍ إرسال الطلب',
  'earlyAccess.success.title': 'تم استلام الطلب',
  'earlyAccess.success.body':
    'شكرًا لك. تم استلام طلب الوصول المبكر. لم يتم إرسال دعوة بعد.',
  'earlyAccess.error.title': 'تعذر إرسال الطلب',
  'earlyAccess.error.body':
    'راجع بياناتك وحاول مرة أخرى. إذا استمرت المشكلة، حاول لاحقًا.',
  'earlyAccess.validation.name': 'أدخل اسمك.',
  'earlyAccess.validation.email': 'أدخل بريدًا إلكترونيًا صحيحًا.',
  'earlyAccess.validation.interestedAs': 'اختر صفتك في الاهتمام بووركرايز.',
  'earlyAccess.validation.consent':
    'يرجى تأكيد موافقتك على التواصل معك بخصوص الوصول المبكر.',
  'earlyAccess.haveAccount': 'لديك حساب بالفعل؟',
  'earlyAccess.signIn': 'تسجيل الدخول',
  'earlyAccess.fromGoogle.notice':
    'لم نتمكن من العثور على حساب ووركرايز لبريد Google هذا بعد. ووركرايز متاح بالدعوة فقط خلال الوصول المبكر — انضم إلى قائمة الانتظار أدناه وسنتواصل معك.',
} as const;
